export default {
    objToQuery (obj) {
       let str = [];
       for(let p in obj) {
           if (obj.hasOwnProperty(p)) {
               str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
           }
       }
       return str.join("&");
    },
    validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    },
    validateMovil(movil) {
        var re = /^(\+34|0034|34)?[ -]*(6|7)[ -]*([0-9][ -]*){8}$/
        return re.test(String(movil).toLowerCase());
    }
}
